import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

interface InsensitiveSearchParams {
  get: (key: string) => string | null;
}

export default function useInsensitiveSearchParams() {
  const searchParams = useSearchParams();

  return useMemo<InsensitiveSearchParams>(() => {
    const newParams = new URLSearchParams();
    for (const [name, value] of searchParams) {
      newParams.append(name.toLocaleLowerCase(), value);
    }

    return { get: (key: string) => newParams.get(key.toLocaleLowerCase()) };
  }, [searchParams]);
}
